<template>
  <div class='cm-chapter-dropdowns'>
    <CmSelect
      v-model="chapter"
      nullLabel="City"
      includeSearch
      :options="chapters.map(chapter => ({label: chapter.name, value: chapter.abbreviation}))"
    />
  </div>
</template>

<script>
  import axios from 'axios';
  import CmSelect from './select'

  export default {
    components: {
      CmSelect
    },

    data () {
      return {
        chapter: null,
        response: null,
      }
    },

    created () {
      axios.get('/cities.json').then(response => {
        this.response = response
      })
    },

    computed: {
      chapters () {
        return (this.response && this.response.data) || []
      },
    },

    watch: {
      chapter (nextAbbreviation, prevAbbreviation) {
        window.location = `/cities/${nextAbbreviation}`
      }
    }
  }
</script>

<style lang="scss" scoped>
.cm-chapter-dropdowns {
  & /deep/ .cm-select__popup {
    @include min-width($bp_medium) {
      left: auto;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/cm-chapter-dropdowns.vue?3b8f2502